module.exports = __webpack_public_path__ + "src/img/tips.8432808c.svg";